import { InitialFieldsAlignment } from "@/type/core/dashboard/dashboard.types";
import { Collapse } from "antd";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
const { Panel } = Collapse;

interface AlignmentDropdownProps {
  alignment: InitialFieldsAlignment;
  handleClick: (alignment: InitialFieldsAlignment) => void;
  className?: string;
}

const AlignmentDropdown: FunctionComponent<AlignmentDropdownProps> = ({
  alignment,
  handleClick,
  className,
}) => {
  const { t } = useTranslation();
  // 1 means active, 0 mean not active
  const [active, setActive] = useState<number>(0);

  const changeCollapseState = () => {
    active === 0 ? setActive(1) : setActive(0);
  };

  const availableAlignments: InitialFieldsAlignment[] = [
    "left",
    "center",
    "right",
  ];

  return (
    <Collapse
      activeKey={active}
      onChange={changeCollapseState}
      expandIconPosition="end"
      size="small"
      bordered={false}
      className={`custom-collapse ${className}`}
    >
      <Panel
        header={t(`signature.positioning.initialFields.alignment.${alignment}`)}
        key="1"
      >
        {availableAlignments.map((availableAlignment, index) => (
          <span
            key={`AlignmentDropdown_availableAlignment_${index}`}
            className={`d-flex list-group-item list-group-item-action justify-content-center text-nowrap cursor-pointer ${availableAlignment === alignment ? "bg-primary text-white" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick(availableAlignment);
              changeCollapseState();
            }}
          >
            {t(
              `signature.positioning.initialFields.alignment.${availableAlignment}`,
            )}
          </span>
        ))}
      </Panel>
    </Collapse>
  );
};

export default AlignmentDropdown;
